import { RootState } from '../../store';

export const getUserPermissionsSelector = (state: RootState) => state.authReducer.permissions;
